import { icon } from "../lib/icons";
import { DEMO_SCHOOL_SLUG } from "../lib/supabase";

export function loginHTML(): string {
  return `
<main class="login-shell" x-data="login()" aria-labelledby="login-title">
  <div class="login-card">
    <span class="brand" style="margin-bottom: 18px">
      <span class="brand-mark" aria-hidden="true">${icon("plane", 13, 1.6, "white")}</span>
      Runway Sync<small>OPS</small>
    </span>
    <h1 id="login-title" style="font-size: 22px; margin: 0 0 6px">Sign in</h1>
    <p class="muted" style="font-size: 13px; margin: 0 0 18px">
      We'll email you a magic link. No passwords.
    </p>
    <form @submit.prevent="submit()" class="login-form">
      <label class="field">
        <span class="field-label">Email</span>
        <input type="email" class="input" x-model="email" required autocomplete="email"
          placeholder="you@flightschool.in" />
      </label>
      <label class="field">
        <span class="field-label">School slug</span>
        <input type="text" class="input mono" x-model="schoolSlug" required
          aria-describedby="school-slug-hint"
          placeholder="${DEMO_SCHOOL_SLUG}" />
        <span id="school-slug-hint" class="muted" style="font-size: 11px; margin-top: 4px">
          Required on first sign-in. Ask your school admin.
        </span>
      </label>
      <button type="submit" class="btn btn-primary" :disabled="$store.session.signInPending">
        <span x-text="$store.session.signInPending ? 'Sending…' : 'Send magic link'"></span>
      </button>
      <div class="muted" role="status" aria-live="polite" style="font-size: 12px; margin-top: 6px"
        x-show="$store.session.signInMessage"
        x-text="$store.session.signInMessage"></div>
    </form>
    <div style="margin-top: 16px; padding-top: 16px; border-top: 1px solid var(--ink-100)">
      <button type="button" class="btn btn-ghost btn-sm" @click="$store.app.exitApp()">
        ← Back to showcase
      </button>
    </div>
  </div>
</main>
`;
}

export function loginAlpine() {
  return {
    email: "",
    schoolSlug: DEMO_SCHOOL_SLUG,
    async submit() {
      const sess = (window as unknown as {
        Alpine: {
          store(name: string): {
            signIn(email: string, slug: string): Promise<{ ok: boolean }>;
          };
        };
      }).Alpine.store("session");
      await sess.signIn(this.email, this.schoolSlug);
    },
  };
}
